import dayjs, { Dayjs } from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";

import { getLast7DaysRange } from "./getLast7DaysRange";

import { DateFilterPeriod, DateFilterType } from "@/shared/model/types/date";

dayjs.extend(isoWeek);

export const getPeriodDateRange = (
    period: DateFilterPeriod,
    now: Dayjs = dayjs(),
): DateFilterType => {
    const today = now.startOf("day");

    switch (period) {
        case "today":
            return [today, today];
        case "yesterday": {
            const yesterday = today.subtract(1, "day");
            return [yesterday, yesterday];
        }
        case "this_week":
            return [today.startOf("isoWeek"), today];
        case "last_week": {
            const lastWeek = today.subtract(1, "week");
            return [lastWeek.startOf("isoWeek"), lastWeek.endOf("isoWeek").startOf("day")];
        }
        case "this_month":
            return [today.startOf("month"), today];
        case "last_month": {
            const lastMonth = today.subtract(1, "month");
            return [lastMonth.startOf("month"), lastMonth.endOf("month").startOf("day")];
        }
        case "last_7_days":
            return getLast7DaysRange(today);
        case "last_14_days":
            return [today.subtract(13, "day"), today];
        case "last_30_days":
            return [today.subtract(29, "day"), today];
        case "last_90_days":
            return [today.subtract(89, "day"), today];
        case "this_year":
            return [today.startOf("year"), today];
    }
};
